import React from "react";

import { getMenuImportTemplate } from "services/menu/rest";

import { saveBlobAsFile } from "shared/lib/downloadFile";
import { Button, ChevronRightIcon, Modal, Stack, UploadIcon } from "shared/ui";

import { useMenuEditorContext } from "features/MenuEditor/context";

import { Row, RowChevron, RowHint, RowIcon, RowText, RowTitle } from "./styles";

interface PanelRow {
    key: string;
    icon: React.ReactNode;
    title: string;
    hint: string;
    onClick: () => void;
}

/*
* Панель осталась только про импорт и экспорт. Порядок категорий и позиций, настройки
* категории, стоп-лист и настройки меню отсюда убраны: каждое из этих действий доступно
* там, где оно применяется (сайдбар, «⋯» категории, заголовок категории, шапка), и
* дублировать их списком — снова разводить два места для одного и того же.
* */
export const MenuManagementPanel = () => {
    const state = useMenuEditorContext();

    const downloadTemplate = async () => {
        try {
            saveBlobAsFile(await getMenuImportTemplate(), "menu-template.xlsx");
        } catch (error) {
            state.notify.showError("Не удалось скачать шаблон", error);
        }
    };

    const rows: PanelRow[] = [
        {
            key: "upload",
            icon: <UploadIcon />,
            title: "Загрузить позиции из файла",
            hint: "Excel или CSV. Добавит новые позиции и обновит существующие",
            onClick: () => state.openDialog({ kind: "upload" }),
        },
        {
            key: "template",
            icon: <UploadIcon />,
            title: "Скачать шаблон таблицы",
            hint: "Пустой xlsx с нужными колонками — заполните и загрузите обратно",
            onClick: downloadTemplate,
        },
    ];

    return (
        <Modal
            open
            onClose={state.closeDialog}
            title="Управление меню"
            actions={
                <Button variant="outlined" color="neutral" onClick={state.closeDialog}>
                    Закрыть
                </Button>
            }
        >
            <Stack $gap={8}>
                {rows.map((row) => (
                    <Row key={row.key} type="button" onClick={row.onClick}>
                        <RowIcon>{row.icon}</RowIcon>
                        <RowText>
                            <RowTitle>{row.title}</RowTitle>
                            <RowHint>{row.hint}</RowHint>
                        </RowText>
                        <RowChevron>
                            <ChevronRightIcon />
                        </RowChevron>
                    </Row>
                ))}
            </Stack>
        </Modal>
    );
};
